import { BrandID } from '../enums/brand-id';
import {LeadTimeUtils} from './lead-time-utils';
import { ProjectProductType } from '../enums/project-product-type';
import { Entity } from '../entity/entity';
import { EntityLineHeader } from '../entity/entity-line-header';

export class EntityUtils {
  static createBrandSelectionKey(brandID: BrandID, projectProductType: ProjectProductType): string {
    return brandID + '-' + projectProductType;
  }

  static determineEntityType(entityId: string): string {
    return entityId.startsWith('QT') ? 'QUOTE' : 'CONTRACT';
  }

  static isApprovedOrFrozen(entity: Entity): boolean {
    return !!(entity && entity.approvalStatus && (entity.approvalStatus.indexOf('Approved') >= 0 || entity.frozen));
  }

  static isCommercialQuickShip(leadTimeCode: string): boolean {
    return !!(leadTimeCode && (leadTimeCode === 'QSC2' || leadTimeCode === 'QSC3'));
  }

  static isResidentialQuickShip(leadTimeCode: string): boolean {
    return !!(leadTimeCode && (leadTimeCode === 'QSR2' || leadTimeCode === 'QSR3'));
  }

  static isMultipleRelease(releaseType: string): boolean {
    return 'MR' === releaseType;
  }

  static isSingleRelease(releaseType: string): boolean {
    return 'SR' === releaseType;
  }

  static getConfiguredQuantity(entity: Entity): number {
    const lines: EntityLineHeader[] = entity?.lines || [];
    const filtered: EntityLineHeader[] = lines.filter((line: EntityLineHeader) => line.configured);
    let qty = 0;
    for (const header of filtered) {
      qty += header.quantity;
    }
    return qty;
  }

  static isStockUnitLine(entity: Entity, line: EntityLineHeader): boolean {
    return LeadTimeUtils.isStockProgram(entity?.leadTimeCode) && !!line?.configured;
  }

  static isConfigurableLine(entity: Entity, line: EntityLineHeader): boolean {
    return !!line?.configured && !EntityUtils.isStockUnitLine(entity, line);
  }

  static isIncompleteLine(entity: Entity, line: EntityLineHeader): boolean {
    return EntityUtils.isConfigurableLine(entity, line) && !line.configurationComplete;
  }
}
